import CloseIcon from "@mui/icons-material/Close";
import CategoryCard from "./CategoryCard/index.js";
import style from "./style.module.scss";

const SubMenu = ({ categories, onClick, onMouseLeave }) => (
  <div className={style.subMenu} onMouseLeave={onMouseLeave}>
    <div className={style.container}>
      {Object.values(categories).map((category) => (
        <CategoryCard key={category.cat_ID} category={category} />
      ))}
    </div>

    <div className={style.closeBtn} onClick={onClick}>
      <CloseIcon />
    </div>
  </div>
);

export default SubMenu;
